import churchs from '../../assets/images/churchs.png'
import ok from '../../assets/images/ok.png'
import piccadilly from '../../assets/images/piccadilly.png'
import kw from '../../assets/images/KW.png'
import carls from '../../assets/images/carls.png'
import falcon from '../../assets/images/falcon.png'
import hardees from '../../assets/images/hardees.png'

export const Images = {
  churchs,
  ok,
  piccadilly,
  kw,
  carls,
  falcon,
  hardees,
} as const

export type ImageKey = keyof typeof Images
